import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";


import { Returncomma } from "../Class/Class_Etc";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import ConfigETC from "../Class/ConfigETC.json";
import SelectTimeoff from "../Library/Select_Timeoff";
import SelectStaff from "../Library/Select_Staff";
import SelectStaffByProject from "../Library/Select_StaffByProject";
import SelectProjectByTimeSheetBySearch from "../Library/Select_ProjectByTimeSheet";
import SelectTaskMultiGroup from "../Library/Select_TaskMultiGroup";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";

import { customStylesSelect } from "../Class/Class_Etc";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import { Bind_Select_Status, Bind_Presets_Calendar } from "../Class/Class_Etc";

import CellDayProject from "../PartialView/PV_TimesheetByStaff_Cell_DayProject";
import SelectCustomer from "../Library/Select_Customer";
import { CP_CheckPermission } from "../Class/Class_Permission";

import { 
    Class_ETC_MsgError
   ,Class_ETC_SessionTimeOut
   ,date_pickerStyle
   ,ReturncommaCustom
} from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
/*
// Add By POOM : 2023-09-29
//    isReport                 = 0 = มาจากหน้า Project View , 1 = มาจากหน้า Report 
//    Pro_id(string)           = ถ้ากรณีที่ isReport = 0 จะต้องระบุ pro_id เพื่อไป fix ใช้งาน

    Edit By POOM : 2024-05-08
      ต้องเพิ่มคอลัมภ์แสดง Expenses  2 ช่อง ได้แก่ 
    - จำนวนวัน  (วางหลัง PER DIEM )
    - ระยะทาง(กม.) วางไว้หลัง ช่อง TRAVEL
    - เพิ่ม fillter search customer    

    Edit BY POOM : 09-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
    
    Edit BY POOM : 14-05-2024 
      - แก้ไข DDL Project ให้ Filter ตาม cus_id
    
    Edit BY Krisana : 30-05-2024
      - แก้ไขโดย เพิ่มปุ่ม Print Document (excel, pdf)
      - เพิ่ม Pro_name ส่งค่า ชื่อ Project เพื่อนำไปออกบน Report ในกรณีที่ดูข้อมูล ByStaff

    Edit BY Krisana : 31-05-2024
      - แก้ไขโดยใส่ setIsLoadProgress(true) ตอน Print Document (excel, pdf)

*/
function PV_TimesheetbyStaff(props) {
  const { isReport, Pro_id, Pro_name } = props;

  //#region __ Declare __

  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const animatedComponents = makeAnimated();

  const [isFirst, setIsFirst] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [configData, setConfigData] = useState([]);
  const [iscntreset, setIscntreset] = useState(0);
  const [bindProjectBycusid, setBindProjectBycusid] = useState(0);

  const [iscntresettimeoff, setIscntresettimeoff] = useState(0);
  const [iscntresetTask, setIscntresetTask] = useState(0);
  const [isLoadGoto, setIsLoadGoto] = useState(false);
  const [isselectTimeoff, setIsselectTimeoff] = useState(true);
  const [isselectTask, setIsselectTask] = useState(false);
  const [isshowDetailTs, setIsshowDetailTs] = useState(false);
  const [calendaractive, setCalendaractive] = useState("");
  const [issearch, setIssearch] = useState(0);
  const [icontoday, setIcontoday] = useState("");

  const current = new Date();
  const dateToday =
    (current.getDate() < 10 ? "0" : "") +
    current.getDate().toString() +
    "/" +
    ((current.getMonth() + 1 < 10 ? "0" : "") +
      (current.getMonth() + 1).toString()) +
    "/" +
    (current.getFullYear() > 2500
      ? current.getFullYear() - 543
      : current.getFullYear()
    ).toString();

  const [isholiday_sun, setIsholiday_sun] = useState("");
  const [isholiday_mon, setIsholiday_mon] = useState("");
  const [isholiday_tue, setIsholiday_tue] = useState("");
  const [isholiday_wed, setIsholiday_wed] = useState("");
  const [isholiday_thu, setIsholiday_thu] = useState("");
  const [isholiday_fri, setIsholiday_fri] = useState("");
  const [isholiday_sat, setIsholiday_sat] = useState("");

  const [total_allday_sun_hr, setTotal_allday_sun_hr] = useState("");
  const [total_allday_sun_mm, setTotal_allday_sun_mm] = useState("");
  const [total_allday_mon_hr, setTotal_allday_mon_hr] = useState("");
  const [total_allday_mon_mm, setTotal_allday_mon_mm] = useState("");
  const [total_allday_tue_hr, setTotal_allday_tue_hr] = useState("");
  const [total_allday_tue_mm, setTotal_allday_tue_mm] = useState("");
  const [total_allday_wed_hr, setTotal_allday_wed_hr] = useState("");
  const [total_allday_wed_mm, setTotal_allday_wed_mm] = useState("");
  const [total_allday_thu_hr, setTotal_allday_thu_hr] = useState("");
  const [total_allday_thu_mm, setTotal_allday_thu_mm] = useState("");
  const [total_allday_fri_hr, setTotal_allday_fri_hr] = useState("");
  const [total_allday_fri_mm, setTotal_allday_fri_mm] = useState("");
  const [total_allday_sat_hr, setTotal_allday_sat_hr] = useState("");
  const [total_allday_sat_mm, setTotal_allday_sat_mm] = useState("");

  const [total_allday_allweek_hr, setTotal_allday_allweek_hr] = useState("");
  const [total_allday_allweek_mm, setTotal_allday_allweek_mm] = useState("");

  const [dt_Full_sun, setDt_Full_sun] = useState("");
  const [dt_Full_mon, setDt_Full_mon] = useState("");
  const [dt_Full_tue, setDt_Full_tue] = useState("");
  const [dt_Full_wed, setDt_Full_wed] = useState("");
  const [dt_Full_thu, setDt_Full_thu] = useState("");
  const [dt_Full_fri, setDt_Full_fri] = useState("");
  const [dt_Full_sat, setDt_Full_sat] = useState("");


  const dataPresets = Bind_Presets_Calendar();
  const [searchStaff, setSearchStaff] = useState(null);
  const [searchstatus, setSearchstatus] = useState(null);
  const [searchProject, setSearchProject] = useState(null);
  const [searchTimeoff, setSearchTimeoff] = useState(null);
  const [searchTask, setSearchTask] = useState(null);
  const [selectedViewtime, setSelectedViewtime] = useState("wt");
  const [searchShowAll, setSearchShowAll] = useState(false);
  const [searchCus, setSearchCus] = useState(null);

  const [valuesearchDateS, setValuesearchDateS] = useState("");
  const [valuesearchDateE, setValuesearchDateE] = useState("");
  const [valuesearchStaff, setValueSearchStaff] = useState("");
  const [valuesearchstatus, setValueSearchstatus] = useState("");
  const [valuesearchProject, setValueSearchProject] = useState("");
  const [valuesearchTimeoff, setValueSearchTimeoff] = useState("");
  const [valuesearchTask, setValueSearchTask] = useState("");
  const [valueselectedViewtime, setValueSelectedViewtime] = useState("wt");
  const [valuesearchShowAll, setValueSearchShowAll] = useState(0);
  const [valuesearchCus, setValueSearchCus] = useState("");
  
  const [start_date_byproject, setStart_date_byproject] = useState("");

  const [listweekbar, setListweekbar] = useState([]);
  const [listDetailTS, setListDetailTS] = useState([]);
  const [listDetailTSWStaff, setListDetailTSWStaff] = useState([]);
  const [act_ShowDetail, setAct_ShowDetail] = useState(1); /* 1 = show all staff , 2 = show 1 staff */
  const [valuestaff_detail, setValuestaff_detail] = useState("");
  const [valuestaffname_detail, setValuestaffname_detail] = useState("");


  
  const [data_modalTS_Extra, setData_modalTS_Extra] = useState(0.00);
  const [data_modalTS_Travel, setData_modalTS_Travel] = useState(0.00);
  const [data_modalTS_Other, setData_modalTS_Other] = useState(0.00);
  const [data_modalTS_Extra_day, setData_modalTS_Extra_day] = useState(0.00);
  const [data_modalTS_Travel_distance, setData_modalTS_Travel_distance] = useState(0.00);
  

  const [data_modalTS_ActProject, setData_modalTS_ActProject] = useState(null);
  const [data_modalTS_act_task_timeoff, setData_modalTS_act_task_timeoff] = useState(null);

  const [data_modalTS_tss, setData_modalTS_tss] = useState(0);
  const [data_modalTS_tsssn, setData_modalTS_tsssn] = useState("");
  const [data_modalTS_tsrd, setData_modalTS_tsrd] = useState("");
  const [data_modalTS_tsrd2, setData_modalTS_tsrd2] = useState("");
  const [data_modalTS_tsrd3, setData_modalTS_tsrd3] = useState("");
  const [data_modalTS_ud, setData_modalTS_ud] = useState("");

  const [data_modalTS_usn, setData_modalTS_usn] = useState("");
  const [data_modalTS_tsd, setData_modalTS_tsd] = useState("");

  const [data_modalTS_Task, setData_modalTS_Task] = useState("");
  const [data_modalTS_SubTask, setData_modalTS_SubTask] = useState("");
  const [data_modalTS_Timeoff, setData_modalTS_Timeoff] = useState("");
  
  const [data_modalTS_wt_time, setData_modalTS_wt_time] = useState(""); 
  const [data_modalTS_ot_time, setData_modalTS_ot_time] = useState(""); 
  
  const h_holi = "text-center-input align-top bg-light";
  const h_nholi = "text-center-input align-top";

  const b_holi = "bg-light";
  const b_nholi = "";

  //#region Weekbar

  const itemsdesktop = 10;
  const itemstablet = 2;
  const itemsmobile = 2;
  const _slidesToslide = 2;

  const desktopmax = 9000;
  const tabletmax = 768;
  const mobilemax = 600;
  const delay_loadslinde = 1;

  const previousSlide_default = -5;
  const nowSlide_default = 1;
  const nextSlide_default = 7;
  const checknextSlide_default = 6;
  const [previousSlide, setPreviousSlide] = useState(previousSlide_default);
  const [nowSlide, setNowSlide] = useState(nowSlide_default);
  const [nextSlide, setNextSlide] = useState(nextSlide_default);
  const [checknextSlide, setChecknextSlide] = useState(checknextSlide_default);

  //#endregion

  //#region Report

  const [start_date, setStart_date] = useState("");
  const [labelsearchStaff, setLabelSearchStaff] = useState("");
  const [labelsearchCus, setLabelSearchCus] = useState("");
  const [labelsearchProject, setLabelSearchProject] = useState("");
  const [labelsearchTask, setLabelSearchTask] = useState("");
  const [labelsearchStatus, setLabelSearchStatus] = useState("");
  const [labelsearchTimeoff, setLabelSearchTimeoff] = useState("");
  const [labelsearchValueDayMonthShow, setLabelSearchValueDayMonthShow] = useState("");

  //#endregion



  //#endregion

  //#region __ use Effect __

  useEffect(() => {
    if (isFirst === true) {
      setIsLoadProgress(true);
      GetConfig();
      if (isLoadedConfigData === true) {
        BindlistweekbarBar("0", "0", "", function () {
          setIsFirst(false);
          if (window.innerWidth < tabletmax) {
            document.getElementById("hd_Slideindex_Goto").value = "3";
            setIsLoadGoto(true);
          } else {
            setIsLoadProgress(false);
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  useEffect(() => {
    if (isLoadGoto) {
      let timer1 = setTimeout(() => {
        document.getElementById("btn_GotoSet").click();
        setIsLoadGoto(false);
        setIsLoadProgress(false);
      }, delay_loadslinde * 500);
      return () => {
        clearTimeout(timer1);
      };
    }
  }, [isLoadGoto]);

  //#endregion

  //#region __ Function __

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  function BindlistweekbarBar(week_beforeafter, slidesToslide, act, _callback) {
    BindlistweekbarBarAPI(
      week_beforeafter,
      slidesToslide,
      act,
      0,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "wt",
      0,
      "",
      function () {
        if (_callback != null) {
          _callback();
        }
      }
    );
  }

  async function BindlistweekbarBarAPI(
    week_beforeafter,
    slidesToslide,
    act,
    _issearch,
    ValueStatus,
    ValueProject,
    ValueTimeoff,
    ValueTask,
    ValueDateStart,
    ValueDataEnd,
    ValueStaffCode,
    ValueViewTime,
    ValueShowAll,
    ValueCus,
    _callback
  ) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw;
      let response;
      var requestOptions;

      raw = JSON.stringify({
        week_beforeafter: week_beforeafter,
        slidesToSlide: slidesToslide,
        isSearch: _issearch.toString(),
        search_date_start: ValueDateStart,
        search_date_end: ValueDataEnd,
        search_project: ValueProject,
        search_task: ValueTask,
        search_timeoff: ValueTimeoff,
        search_stauts: ValueStatus,
        search_staff_code: ValueStaffCode,
        isReport: isReport.toString(),
        isShowAll: ValueShowAll.toString(),
        showTime: ValueViewTime,
        search_cus: ValueCus,
      });

      requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      response = await fetch(
        configData.API_URL + "Report_GetsumTimesheetbyStaff_weekbar",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) { 
          if (act === "next") {
            setListweekbar((listweekbar) => [...listweekbar, ...json.data]);
            if (_callback != null) {
              _callback();
            }
          } else if (act === "previous") {
            setListweekbar((listweekbar) => [...json.data, ...listweekbar]);
            if (_callback != null) {
              _callback();
            }
          } else {
            setPreviousSlide(previousSlide_default);
            setNowSlide(nowSlide_default);
            setNextSlide(nextSlide_default);
            setChecknextSlide(checknextSlide_default);
            setListweekbar(json.data);

            let DS = "";
            let uid = "";

            if (_issearch === 1) {
              DS = json.data[json.total_Data - 1].date_Start;
              uid = json.data[json.total_Data - 1].uniqueid;
            } else {
              DS = json.data[0].date_weektoday;
              uid = json.data[0].uniqueid_today;
            }

            if (DS !== "") {
              setIsshowDetailTs(true);
              setCalendaractive(uid);
              const Vssp = json.data.filter((e) => e.uniqueid === uid);

              BindsetValueisHoliday(
                Vssp[0].isholiday_sun,
                Vssp[0].isholiday_mon,
                Vssp[0].isholiday_tue,
                Vssp[0].isholiday_wed,
                Vssp[0].isholiday_thu,
                Vssp[0].isholiday_fri,
                Vssp[0].isholiday_sat
              );

              BindsetValuedt(
                Vssp[0].dt_date_sun,
                Vssp[0].dt_date_mon,
                Vssp[0].dt_date_tue,
                Vssp[0].dt_date_wed,
                Vssp[0].dt_date_thu,
                Vssp[0].dt_date_fri,
                Vssp[0].dt_date_sat
                , Vssp[0].dt_Full_sun
                , Vssp[0].dt_Full_mon
                , Vssp[0].dt_Full_tue
                , Vssp[0].dt_Full_wed
                , Vssp[0].dt_Full_thu
                , Vssp[0].dt_Full_fri
                , Vssp[0].dt_Full_sat
              );

              setLabelSearchValueDayMonthShow(Vssp[0].dayShow + " " + Vssp[0].monthShow);
              
              if (act_ShowDetail === 1) {
                BindListDetailTS(
                  DS,
                  _issearch,
                  ValueDateStart,
                  ValueDataEnd,
                  ValueProject,
                  ValueTimeoff,
                  ValueStatus,
                  ValueTask,
                  ValueStaffCode,
                  ValueViewTime,
                  ValueShowAll,
                  ValueCus,
                  function () {
                    if (_issearch === 1) {
                      let cntitem = 0;
                      if (window.innerWidth < tabletmax) {
                        cntitem = itemstablet;
                      } else {
                        cntitem = itemsdesktop;
                      }

                      if (json.total_Data - cntitem > 0) {
                        document.getElementById("hd_Slideindex_Goto").value =
                          json.total_Data - cntitem;
                        setIsLoadGoto(true);
                        // ไม่ต้อง callback เพราะ เดี๋ยวมันจะ ปิด progress ที่ฝั่ง IsLoadGoto บน useeffect เอง
                      } else {
                        if (_callback != null) {
                          _callback();
                        }
                      }
                    } else {
                      if (_callback != null) {
                        _callback();
                      }
                    }
                  }
                );
              } else {

                BindListDetailTS_Staff(
                  DS,
                  _issearch,
                  ValueDateStart,
                  ValueDataEnd,
                  ValueProject,
                  ValueTimeoff,
                  ValueStatus,
                  ValueTask,
                  valuestaff_detail,
                  ValueViewTime,
                  ValueShowAll,
                  ValueCus,
                  function () {
                    if (_issearch === 1) {
                      let cntitem = 0;
                      if (window.innerWidth < tabletmax) {
                        cntitem = itemstablet;
                      } else {
                        cntitem = itemsdesktop;
                      }

                      if (json.total_Data - cntitem > 0) {
                        document.getElementById("hd_Slideindex_Goto").value =
                          json.total_Data - cntitem;
                        setIsLoadGoto(true);
                        // ไม่ต้อง callback เพราะ เดี๋ยวมันจะ ปิด progress ที่ฝั่ง IsLoadGoto บน useeffect เอง
                      } else {
                        if (_callback != null) {
                          _callback();
                        }
                      }
                    } else {
                      if (_callback != null) {
                        _callback();
                      }
                    }
                  }
                );
              }
            } else {
              if (_callback != null) {
                _callback();
              }
            }
          }
        } else {
          setIsshowDetailTs(false);
          setListweekbar([]);
          setListDetailTS([]);
          setListDetailTSWStaff([]);
          if (_callback != null) {
            _callback();
          }
        }
      } else {
        setIsshowDetailTs(false);
        setListweekbar([]);
        setListDetailTS([]);
        setListDetailTSWStaff([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setIsshowDetailTs(false);
      setListweekbar([]);
      setListDetailTS([]);
      setListDetailTSWStaff([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindListDetailTS(
    date_Start,
    _issearch,
    _searchdateS,
    _searchdateE,
    _searchProject,
    _searchTimeoff,
    _searchstatus,
    _searchTask,
    _searchStaffCode,
    _searchViewTime,
    _searchShowAll,
    _searchCus,
    _callback
  ) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw;

      setStart_date(date_Start);
      
      raw = JSON.stringify({
        date_Start: date_Start,
        isSearch: _issearch.toString(),
        search_date_start: _searchdateS,
        search_date_end: _searchdateE,
        search_project: isReport === 1 ? _searchProject : Pro_id,
        search_task: _searchTask,
        search_timeoff: _searchTimeoff,
        search_stauts: _searchstatus,
        search_staff_code: _searchStaffCode,
        isReport: isReport.toString(),
        isShowAll: _searchShowAll.toString(),
        showTime: _searchViewTime,
        search_Cus: _searchCus,
      });

      setListDetailTS([]);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      let response;
      response = await fetch(
        configData.API_URL + "Report_GetsumTimesheetbyStaff_DetailTimesheet",
        requestOptions
      );

      setStart_date_byproject(date_Start);
      datatext_Projectday(date_Start);
      const json = await response.json();
      setIsshowDetailTs(true);
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListDetailTS(json.data);
          setTotal_allday_sun_hr(json.data[0].total_allday_sun_hr);
          setTotal_allday_sun_mm(json.data[0].total_allday_sun_mm);
          setTotal_allday_mon_hr(json.data[0].total_allday_mon_hr);
          setTotal_allday_mon_mm(json.data[0].total_allday_mon_mm);
          setTotal_allday_tue_hr(json.data[0].total_allday_tue_hr);
          setTotal_allday_tue_mm(json.data[0].total_allday_tue_mm);
          setTotal_allday_wed_hr(json.data[0].total_allday_wed_hr);
          setTotal_allday_wed_mm(json.data[0].total_allday_wed_mm);
          setTotal_allday_thu_hr(json.data[0].total_allday_thu_hr);
          setTotal_allday_thu_mm(json.data[0].total_allday_thu_mm);
          setTotal_allday_fri_hr(json.data[0].total_allday_fri_hr);
          setTotal_allday_fri_mm(json.data[0].total_allday_fri_mm);
          setTotal_allday_sat_hr(json.data[0].total_allday_sat_hr);
          setTotal_allday_sat_mm(json.data[0].total_allday_sat_mm);

          setTotal_allday_allweek_hr(json.data[0].total_allday_allweek_hr);
          setTotal_allday_allweek_mm(json.data[0].total_allday_allweek_mm);

          if (_callback != null) {
            _callback();
          }
        } else {
          setListDetailTS([]);
          ResetTotalAllDay();
          datatext_Projectday(date_Start);
          if (_callback != null) {
            _callback();
          }
        }
      } else {
        setListDetailTS([]);
        ResetTotalAllDay();
        datatext_Projectday(date_Start);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setListDetailTS([]);
      ResetTotalAllDay();
      datatext_Projectday(date_Start);
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindListDetailTS_Staff(
    date_Start,
    _issearch,
    _searchdateS,
    _searchdateE,
    _searchProject,
    _searchTimeoff,
    _searchstatus,
    _searchTask,
    _searchStaffCode,
    _searchViewTime,
    _searchShowAll,
    _searchCus,
    _callback
  ) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw;

      setStart_date(date_Start);

      raw = JSON.stringify({
        date_Start: date_Start,
        isSearch: _issearch.toString(),
        search_date_start: _searchdateS,
        search_date_end: _searchdateE,
        search_project: isReport === 1 ? _searchProject : Pro_id,
        search_task: _searchTask,
        search_timeoff: _searchTimeoff,
        search_stauts: _searchstatus,
        search_staff_code: _searchStaffCode,
        isReport: isReport.toString(),
        isShowAll: _searchShowAll.toString(),
        showTime: _searchViewTime,
        search_cus: _searchCus,
      });

      setListDetailTS([]);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      let response;
      response = await fetch(
        configData.API_URL + "Report_GetsumTimesheetbyStaff_DetailTimesheetStaff",
        requestOptions
      );

      setStart_date_byproject(date_Start);
      datatext_Projectday(date_Start);
      const json = await response.json();
      setIsshowDetailTs(true);
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {

          setListDetailTSWStaff(json.data);
          setTotal_allday_sun_hr(json.data[0].total_allday_sun_hr);
          setTotal_allday_sun_mm(json.data[0].total_allday_sun_mm);
          setTotal_allday_mon_hr(json.data[0].total_allday_mon_hr);
          setTotal_allday_mon_mm(json.data[0].total_allday_mon_mm);
          setTotal_allday_tue_hr(json.data[0].total_allday_tue_hr);
          setTotal_allday_tue_mm(json.data[0].total_allday_tue_mm);
          setTotal_allday_wed_hr(json.data[0].total_allday_wed_hr);
          setTotal_allday_wed_mm(json.data[0].total_allday_wed_mm);
          setTotal_allday_thu_hr(json.data[0].total_allday_thu_hr);
          setTotal_allday_thu_mm(json.data[0].total_allday_thu_mm);
          setTotal_allday_fri_hr(json.data[0].total_allday_fri_hr);
          setTotal_allday_fri_mm(json.data[0].total_allday_fri_mm);
          setTotal_allday_sat_hr(json.data[0].total_allday_sat_hr);
          setTotal_allday_sat_mm(json.data[0].total_allday_sat_mm);

          setTotal_allday_allweek_hr(json.data[0].total_allday_allweek_hr);
          setTotal_allday_allweek_mm(json.data[0].total_allday_allweek_mm);

          if (_callback != null) {
            _callback();
          }
        } else {
          setListDetailTSWStaff([]);
          ResetTotalAllDay();
          datatext_Projectday(date_Start);
          if (_callback != null) {
            _callback();
          }
        }
      } else {
        setListDetailTSWStaff([]);
        ResetTotalAllDay();
        datatext_Projectday(date_Start);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setListDetailTSWStaff([]);
      ResetTotalAllDay();
      datatext_Projectday(date_Start);
      if (_callback != null) {
        _callback();
      }
    }
  }

  function ResetTotalAllDay() {
    setTotal_allday_sun_hr("");
    setTotal_allday_sun_mm("");
    setTotal_allday_mon_hr("");
    setTotal_allday_mon_mm("");
    setTotal_allday_tue_hr("");
    setTotal_allday_tue_mm("");
    setTotal_allday_wed_hr("");
    setTotal_allday_wed_mm("");
    setTotal_allday_thu_hr("");
    setTotal_allday_thu_mm("");
    setTotal_allday_fri_hr("");
    setTotal_allday_fri_mm("");
    setTotal_allday_sat_hr("");
    setTotal_allday_sat_mm("");

    setTotal_allday_allweek_hr("");
    setTotal_allday_allweek_mm("");
    
  }

  function BindsetValuedt(
    dt_sun,
    dt_mon,
    dt_tue,
    dt_wed,
    dt_thu,
    dt_fri,
    dt_sat, dt_Full_sun, dt_Full_mon, dt_Full_tue, dt_Full_wed, dt_Full_thu, dt_Full_fri, dt_Full_sat
  ) {
    
    document.getElementById("hdCBP_dt_sun").value = dt_sun;
    document.getElementById("hdCBP_dt_mon").value = dt_mon;
    document.getElementById("hdCBP_dt_tue").value = dt_tue;
    document.getElementById("hdCBP_dt_wed").value = dt_wed;
    document.getElementById("hdCBP_dt_thu").value = dt_thu;
    document.getElementById("hdCBP_dt_fri").value = dt_fri;
    document.getElementById("hdCBP_dt_sat").value = dt_sat;

    
    setDt_Full_sun(dt_Full_sun)
    setDt_Full_mon(dt_Full_mon)
    setDt_Full_tue(dt_Full_tue)
    setDt_Full_wed(dt_Full_wed)
    setDt_Full_thu(dt_Full_thu)
    setDt_Full_fri(dt_Full_fri)
    setDt_Full_sat(dt_Full_sat)
  

  }

  function BindsetValueisHoliday(
    isholiday_sun,
    isholiday_mon,
    isholiday_tue,
    isholiday_wed,
    isholiday_thu,
    isholiday_fri,
    isholiday_sat
  ) {
    setIsholiday_sun(isholiday_sun);
    setIsholiday_mon(isholiday_mon);
    setIsholiday_tue(isholiday_tue);
    setIsholiday_wed(isholiday_wed);
    setIsholiday_thu(isholiday_thu);
    setIsholiday_fri(isholiday_fri);
    setIsholiday_sat(isholiday_sat);
  }

  function datatext_Projectday() {
    let dayicon = "";
    document.getElementById("span_day_sun").innerHTML = document
      .getElementById("hdCBP_dt_sun")
      .value.substring(0, 2);
    dayicon =
      document.getElementById("hdCBP_dt_sun").value === dateToday
        ? "sun"
        : dayicon;

    document.getElementById("span_day_mon").innerHTML = document
      .getElementById("hdCBP_dt_mon")
      .value.substring(0, 2);
    dayicon =
      document.getElementById("hdCBP_dt_mon").value === dateToday
        ? "mon"
        : dayicon;

    document.getElementById("span_day_tue").innerHTML = document
      .getElementById("hdCBP_dt_tue")
      .value.substring(0, 2);
    dayicon =
      document.getElementById("hdCBP_dt_tue").value === dateToday
        ? "tue"
        : dayicon;

    document.getElementById("span_day_wed").innerHTML = document
      .getElementById("hdCBP_dt_wed")
      .value.substring(0, 2);
    dayicon =
      document.getElementById("hdCBP_dt_wed").value === dateToday
        ? "wed"
        : dayicon;

    document.getElementById("span_day_thu").innerHTML = document
      .getElementById("hdCBP_dt_thu")
      .value.substring(0, 2);
    dayicon =
      document.getElementById("hdCBP_dt_thu").value === dateToday
        ? "thu"
        : dayicon;

    document.getElementById("span_day_fri").innerHTML = document
      .getElementById("hdCBP_dt_fri")
      .value.substring(0, 2);
    dayicon =
      document.getElementById("hdCBP_dt_fri").value === dateToday
        ? "fri"
        : dayicon;

    document.getElementById("span_day_sat").innerHTML = document
      .getElementById("hdCBP_dt_sat")
      .value.substring(0, 2);
    dayicon =
      document.getElementById("hdCBP_dt_sat").value === dateToday
        ? "sat"
        : dayicon;
    setIcontoday(dayicon);
  }

  function onclick_reset() {
    setIscntreset((iscntreset) => iscntreset + 1);
    setSearchstatus(null);
    document.getElementById("txt_SearchDate_TSbyStaff").value = "";

    
    setValuesearchDateS("");
    setValuesearchDateE("");
    setValueSearchProject("");
    setValueSearchCus("");
    setValueSearchTask("");
    setValueSearchTimeoff("");
    setValueSearchstatus("");
    setValueSearchStaff("");
    setValueSearchShowAll(0);
    setValueSelectedViewtime("wt");

    setLabelSearchStaff("");
    setLabelSearchCus("");
    setLabelSearchProject("");
    setLabelSearchTask("");
    setLabelSearchStatus("");
    setLabelSearchTimeoff("");

  }

  function Bindendfunction_SP(){
    setIsLoadProgress(false)
  }

 
  function onclick_ReportType_Print(_exportpdf){
    if (act_ShowDetail === 1){
      PrintDocumentAllSatff(_exportpdf);
    } else {
      PrintDocumentByStaff(_exportpdf);
    }
  }

  async function PrintDocumentAllSatff(_exportpdf)
   {    
    setIsLoadProgress(true);
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw;
      raw = JSON.stringify({
        date_Start: isReport === 1 ? start_date : start_date_byproject,
        isSearch: issearch.toString(),
        search_date_start: valuesearchDateS,
        search_date_end:  valuesearchDateE,
        search_project: isReport === 1 ? valuesearchProject : Pro_id,
        search_task: valuesearchTask,
        search_timeoff: valuesearchTimeoff,
        search_stauts:   valuesearchstatus,
        search_staff_code: valuesearchStaff,
        isReport: isReport === 1 ? "1" : "0",
        isShowAll: valuesearchShowAll.toString(),
        showTime: valueselectedViewtime,
        search_cus: isReport === 1 ? valuesearchCus : "",
        exportpdf: (_exportpdf === "pdf" ? 1 : 0),
        staff_name: (labelsearchStaff === "" ? ConfigETC.ddl_All : labelsearchStaff),
        cus_name: (isReport === 1 ? (labelsearchCus === "" ? ConfigETC.ddl_All : labelsearchCus) : ""),
        project_name: (isReport === 1 ? (labelsearchProject === "" ? ConfigETC.ddl_All : labelsearchProject) : Pro_name.toString()),
        task_name:  (labelsearchTask === "" ? ConfigETC.ddl_All : labelsearchTask),
        status_name: (labelsearchStatus === "" ? ConfigETC.ddl_All : labelsearchStatus),
        timeoff_name:  (labelsearchTimeoff === "" ? ConfigETC.ddl_All : labelsearchTimeoff),
        isShowAll_name: (valuesearchShowAll === 1 ? ConfigETC.ddl_All : "Active"),
        daymonthShow: (labelsearchValueDayMonthShow === "" ? ConfigETC.ddl_All : labelsearchValueDayMonthShow),
        dt_sun: document.getElementById("hdCBP_dt_sun").value.substring(0, 2),
        dt_mon: document.getElementById("hdCBP_dt_mon").value.substring(0, 2),
        dt_tue: document.getElementById("hdCBP_dt_tue").value.substring(0, 2),
        dt_wed: document.getElementById("hdCBP_dt_wed").value.substring(0, 2),
        dt_thu: document.getElementById("hdCBP_dt_thu").value.substring(0, 2),
        dt_fri: document.getElementById("hdCBP_dt_fri").value.substring(0, 2),
        dt_sat: document.getElementById("hdCBP_dt_sat").value.substring(0, 2)
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      let response;
      response = await fetch(
        configData.API_URL + "Report_PrintGetsumTimesheetbyStaff_DetailTimesheet",
        requestOptions
      );
      const json = await response.json();
      
      if (json.status_ID === 1) {
          setIsLoadProgress(false);
          if(json.return_Url !== null && json.return_Url !== ""){
              window.open(json.return_Url);
          };
      } 
      else if (json.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
      else {
          setIsLoadProgress(false);
          Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR032, null)
    }
  }

  async function PrintDocumentByStaff(_exportpdf)
   {  
    setIsLoadProgress(true);  
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw;
      raw = JSON.stringify({
        date_Start: isReport === 1 ? start_date : start_date_byproject,
        isSearch: issearch.toString(),
        search_date_start: valuesearchDateS,
        search_date_end:  valuesearchDateE,
        search_project: isReport === 1 ? valuesearchProject : Pro_id,
        search_task: valuesearchTask,
        search_timeoff: valuesearchTimeoff,
        search_stauts:   valuesearchstatus,
        search_staff_code: valuesearchStaff,
        isReport: isReport === 1 ? "1" : "0",
        isShowAll: valuesearchShowAll.toString(),
        showTime: valueselectedViewtime,
        search_cus: isReport === 1 ? valuesearchCus : "",
        exportpdf: (_exportpdf === "pdf" ? 1 : 0),
        staff_name: (labelsearchStaff === "" ? ConfigETC.ddl_All : labelsearchStaff),
        cus_name: (isReport === 1 ? (labelsearchCus === "" ? ConfigETC.ddl_All : labelsearchCus) : ""),
        project_name: (isReport === 1 ? (labelsearchProject === "" ? ConfigETC.ddl_All : labelsearchProject) : Pro_name.toString()),
        task_name:  (labelsearchTask === "" ? ConfigETC.ddl_All : labelsearchTask),
        status_name: (labelsearchStatus === "" ? ConfigETC.ddl_All : labelsearchStatus),
        timeoff_name:  (labelsearchTimeoff === "" ? ConfigETC.ddl_All : labelsearchTimeoff),
        isShowAll_name: (valuesearchShowAll === 1 ? ConfigETC.ddl_All : "Active"),
        daymonthShow: (labelsearchValueDayMonthShow === "" ? ConfigETC.ddl_All : labelsearchValueDayMonthShow),
        dt_sun: document.getElementById("hdCBP_dt_sun").value.substring(0, 2),
        dt_mon: document.getElementById("hdCBP_dt_mon").value.substring(0, 2),
        dt_tue: document.getElementById("hdCBP_dt_tue").value.substring(0, 2),
        dt_wed: document.getElementById("hdCBP_dt_wed").value.substring(0, 2),
        dt_thu: document.getElementById("hdCBP_dt_thu").value.substring(0, 2),
        dt_fri: document.getElementById("hdCBP_dt_fri").value.substring(0, 2),
        dt_sat: document.getElementById("hdCBP_dt_sat").value.substring(0, 2),
        isSVOT: (isSVOT === true ? 1 : 0),
        Staff_CodeWhere: valuestaff_detail,
        staff_fullnameShow: valuestaffname_detail
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      let response;
      response = await fetch(
        configData.API_URL + "Report_PrintGetsumTimesheetbyStaff_DetailTimesheetStaff",
        requestOptions
      );
      const json = await response.json();
      
      if (json.status_ID === 1) {
          setIsLoadProgress(false);
          if(json.return_Url !== null && json.return_Url !== ""){
              window.open(json.return_Url);
          };
      } 
      else if (json.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
      else {
          setIsLoadProgress(false);
          Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR032, null)
    }
  }

  //#endregion

  //#region __ Event __

  function SearchonChangevaluestaff(e) {
    e === null ? setSearchStaff([]) : setSearchStaff(e) ;
  }

  function SearchonChangevalueproject(e) {
    e === null ? setSearchProject([]) : setSearchProject(e) ;
  }

  function SearchonChangevalueCus(e) {
    setSearchCus(e);
    if (e === null)
    {
      document.getElementById("hd_cus_id_search").value = "-1";
    }
    else
    {
      document.getElementById("hd_cus_id_search").value = e.value;
    }
    
    
    setBindProjectBycusid((bindProjectBycusid) => bindProjectBycusid + 1);
    setIsLoadProgress(true);
  }

  function SearchonChangevaluetimeoff(e) {
    e === null ? setSearchTimeoff([]) : setSearchTimeoff(e) ;
  }

  function SearchonChangevalueTask(e) {
    e === null ? setSearchTask([]) : setSearchTask(e) ;
  }

  function SearchonChangevalueStatus(e) {
    e === null ? setSearchstatus([]) : setSearchstatus(e) ;
  }

  const handleRadioViewtimeChange = (event) => {
    setSelectedViewtime(event.target.value);

    if (event.target.value === "tof") {
      setIscntresetTask((iscntresetTask) => iscntresetTask + 1);
      setIsselectTimeoff(false);
      setIsselectTask(true);
    } else {
      setIscntresettimeoff((iscntresettimeoff) => iscntresettimeoff + 1);
      setIsselectTimeoff(true);
      setIsselectTask(false);
    }
  };

  function onclick_viewProject(
    date_Start,
    uniqueid,
    isholiday_sun,
    isholiday_mon,
    isholiday_tue,
    isholiday_wed,
    isholiday_thu,
    isholiday_fri,
    isholiday_sat,
    dt_sun,
    dt_mon,
    dt_tue,
    dt_wed,
    dt_thu,
    dt_fri,
    dt_sat
    ,dt_Full_sun
    ,dt_Full_mon
    ,dt_Full_tue
    ,dt_Full_wed
    ,dt_Full_thu
    ,dt_Full_fri
    ,dt_Full_sat 
    ,dayShow
    ,monthShow
  ) {

    setLabelSearchValueDayMonthShow(dayShow + " " + monthShow);

    setIsLoadProgress(true);
    BindsetValueisHoliday(
      isholiday_sun,
      isholiday_mon,
      isholiday_tue,
      isholiday_wed,
      isholiday_thu,
      isholiday_fri,
      isholiday_sat
    );
    BindsetValuedt(dt_sun, dt_mon, dt_tue, dt_wed, dt_thu, dt_fri, dt_sat , dt_Full_sun, dt_Full_mon, dt_Full_tue, dt_Full_wed, dt_Full_thu, dt_Full_fri, dt_Full_sat);

    if (act_ShowDetail === 1)
    {
      BindListDetailTS(
        date_Start,
        issearch,
        valuesearchDateS,
        valuesearchDateE,
        valuesearchProject,
        valuesearchTimeoff,
        valuesearchstatus,
        valuesearchTask,
        valuesearchStaff,
        valueselectedViewtime,
        valuesearchShowAll,
        valuesearchCus,
        function () {
          setCalendaractive(uniqueid);
          setIsLoadProgress(false);
        }
      );
    }
    else {

      

      BindListDetailTS_Staff(
        date_Start,
        issearch,
        valuesearchDateS,
        valuesearchDateE,
        valuesearchProject,
        valuesearchTimeoff,
        valuesearchstatus,
        valuesearchTask,
        valuestaff_detail,
        valueselectedViewtime,
        valuesearchShowAll,
        valuesearchCus,
        function () {
          setCalendaractive(uniqueid);
          setIsLoadProgress(false);
        }
      );

    }



  }

  const onChange_CBAll = (e) => {
    const { checked } = e.target;
    setSearchShowAll(checked);
  };

  function onclick_search() {
    let ValueDateS = "";
    let ValueDateE = "";
    let ValueStaff = "";
    let ValueProject = "";
    let ValueCus = "";
    let ValueTask = "";
    let ValueStatus = "";
    let ValueTimeoff = "";
    let ValueViewTime = "";
    let ValueShowAll = 0;

    let ValueStaffText = "";
    let ValueCusText = "";
    let ValueProjectText = "";
    let ValueTaskText = "";
    let ValueStatusText = "";
    let ValueTimeoffText = "";
    
    let date_rang = document.getElementById("txt_SearchDate_TSbyStaff").value;
    if (date_rang !== "") {
      let datevalue = date_rang.split(" - ");
      if (datevalue.length === 2) {
        ValueDateS = datevalue[0];
        ValueDateE = datevalue[1];
      }
    }

    if (searchStaff !== null) {
      if (searchStaff.length > 0) {
        for (let i = 0; i < searchStaff.length; i++) {
          ValueStaff = ValueStaff + (ValueStaff === "" ? "" : ",") + searchStaff[i].value;
          ValueStaffText = ValueStaffText + (ValueStaffText === "" ? "" : ",") + searchStaff[i].label;
        }
      }
    }

    if (isReport === 1) {
      if (searchProject !== null) {
        if (searchProject.length > 0) {
          for (let i = 0; i < searchProject.length; i++) {
            ValueProject = ValueProject + (ValueProject === "" ? "" : ",") + searchProject[i].value;
            ValueProjectText = ValueProjectText + (ValueProjectText === "" ? "" : ",") + searchProject[i].label;
          }
        }
      }
    } else {
      ValueProject = Pro_id;
    }

    if (searchCus !== null) {
      if (searchCus.value !== -1){
        ValueCus = searchCus.value.toString();
        ValueCusText = searchCus.label;
      }
      else{
        ValueCus = ""
        ValueCusText = ConfigETC.ddl_All
      }
    }
  
    if (searchTask !== null) {
      if (searchTask.length > 0) {
        for (let i = 0; i < searchTask.length; i++) {
          ValueTask = ValueTask + (ValueTask === "" ? "" : ",") + searchTask[i].value;
          ValueTaskText = ValueTaskText + (ValueTaskText === "" ? "" : ",") + searchTask[i].label;
        }
      }
    }

    if (searchstatus !== null) {
      if (searchstatus.length > 0) {
        for (let i = 0; i < searchstatus.length; i++) {
          ValueStatus = ValueStatus + (ValueStatus === "" ? "" : ",") + searchstatus[i].value;
          ValueStatusText = ValueStatusText + (ValueStatusText === "" ? "" : ",") + searchstatus[i].label;
        }
      }
    }

    if (searchTimeoff !== null) {
      if (searchTimeoff.length > 0) {
        for (let i = 0; i < searchTimeoff.length; i++) {
          ValueTimeoff = ValueTimeoff + (ValueTimeoff === "" ? "" : ",") + searchTimeoff[i].value;
          ValueTimeoffText = ValueTimeoffText + (ValueTimeoffText === "" ? "" : ",") + searchTimeoff[i].label;
        }
      }
    }

    ValueViewTime = selectedViewtime;
    ValueShowAll = searchShowAll === true ? 1 : 0;

    setIssearch(1);
    setIsLoadProgress(true);
    if (listweekbar.length > 0) {
      document.getElementById("hd_Slideindex_Goto").value = "0";
      document.getElementById("btn_GotoSet").click();
    }

    setValuesearchDateS(ValueDateS);
    setValuesearchDateE(ValueDateE);
    setValueSearchProject(ValueProject);
    setValueSearchCus(ValueCus);
    setValueSearchTask(ValueTask);
    setValueSearchTimeoff(ValueTimeoff);
    setValueSearchstatus(ValueStatus);
    setValueSearchStaff(ValueStaff);
    setValueSelectedViewtime(ValueViewTime);
    setValueSearchShowAll(ValueShowAll);

    setLabelSearchStaff(ValueStaffText);
    setLabelSearchCus(ValueCusText);
    setLabelSearchProject(ValueProjectText);
    setLabelSearchTask(ValueTaskText);
    setLabelSearchStatus(ValueStatusText);
    setLabelSearchTimeoff(ValueTimeoffText);

    BindlistweekbarBarAPI(
      "0",
      "0",
      "",
      1,
      ValueStatus,
      ValueProject,
      ValueTimeoff,
      ValueTask,
      ValueDateS,
      ValueDateE,
      ValueStaff,
      ValueViewTime,
      ValueShowAll,
      ValueCus,
      function () {
        setIsLoadProgress(false);
      }
    );
  }

  function onclick_refresh() {
    setIsLoadProgress(true);
    setIssearch(0);
    setSelectedViewtime("wt");
    setSearchShowAll(false);
    setIsselectTimeoff(true);
    setIsselectTask(false);

    onclick_reset();
    if (listweekbar.length > 0) {
      document.getElementById("hd_Slideindex_Goto").value = "0";
      document.getElementById("btn_GotoSet").click();
    }
    BindlistweekbarBar("0", "0", "", function () {
      setIsLoadProgress(false);
    });
  }

  function onclick_showdetailstaff(staff_code , fullName){

    setValuestaff_detail(staff_code);
    setValuestaffname_detail(fullName);
    setAct_ShowDetail(2);
    setIsLoadProgress(true);
    BindListDetailTS_Staff(
      start_date_byproject,
      issearch,
      valuesearchDateS,
      valuesearchDateE,
      valuesearchProject,
      valuesearchTimeoff,
      valuesearchstatus,
      valuesearchTask,
      staff_code,
      valueselectedViewtime,
      valuesearchShowAll,
      valuesearchCus,
      function () {
        setIsLoadProgress(false);
      }
    );

  }

  function onclick_showdetailAll(){
    
    setAct_ShowDetail(1);
    setIsLoadProgress(true);
    BindListDetailTS(
      start_date_byproject,
      issearch,
      valuesearchDateS,
      valuesearchDateE,
      valuesearchProject,
      valuesearchTimeoff,
      valuesearchstatus,
      valuesearchTask,
      valuesearchStaff,
      valueselectedViewtime,
      valuesearchShowAll,
      valuesearchCus,
      function () {
        setIsLoadProgress(false);
      }
    );

  }

  function onclick_ModalEditTimeSheet(
      ActProject 
    , act_task_timeoff
    , project_name
    , day
    , dt_dayFull
    , customer_name
    , taskname
    , tasksubname
    , timeoff_name
    , pos_name
    , ee
    , et
    , eo
    , eed
    , etd
    , desc
    , tsssn
    , tsrd
    , ud
    , tss
    , usn
    , tsd
    , ot_time
    , wt_time
    ){

    document.getElementById("lbl_modalTS_ProjectName").innerHTML = project_name
    document.getElementById("lbl_modalTS_CusName").innerHTML =  customer_name 

    setData_modalTS_Task(taskname);
    setData_modalTS_SubTask(tasksubname);
    setData_modalTS_Timeoff(timeoff_name);
    
    document.getElementById("lbl_modalTS_PositionName").innerHTML = pos_name;

    document.getElementById("lbl_modalTS_Day").innerHTML = "(" + day + ")"
    document.getElementById("lbl_modalTS_Date").innerHTML = dt_dayFull
    if (icontoday.toLowerCase() === day.toLowerCase() && icontoday !== "")
    {
      document.getElementById("i_model_Today").style.display = "";
    }
    else
    {
      document.getElementById("i_model_Today").style.display = "none";
    }

    document.getElementById("lbl_modalTS_Note").innerHTML = desc;

    if (act_task_timeoff === "T"){
      document.getElementById("div_modalTS_Expenses1").style.display = "";
    }
    else
    {
      document.getElementById("div_modalTS_Expenses1").style.display = "none";
    }


    setData_modalTS_ActProject(ActProject);
    setData_modalTS_act_task_timeoff(act_task_timeoff);
    setData_modalTS_Extra(ee);
    setData_modalTS_Travel(et);
    setData_modalTS_Other(eo);

    
    setData_modalTS_Extra_day(eed);
    setData_modalTS_Travel_distance(etd);

    setData_modalTS_tss(tss);
    setData_modalTS_tsssn(tsssn);

    if (tsrd !== "")
    {
      let rejectArray = tsrd.split('|'); 
      if (rejectArray.length === 3){
        setData_modalTS_tsrd(rejectArray[0]);
        setData_modalTS_tsrd2(rejectArray[1]);
        setData_modalTS_tsrd3(rejectArray[2]);
      }
      else
      {
        setData_modalTS_tsrd("");
        setData_modalTS_tsrd2("");
        setData_modalTS_tsrd3("");
      }
    }
    else
    {
      setData_modalTS_tsrd("");
      setData_modalTS_tsrd2("");
      setData_modalTS_tsrd3("");
    }


    setData_modalTS_ud(ud);

    setData_modalTS_usn(usn);
    setData_modalTS_tsd(tsd);
  
    setData_modalTS_wt_time(wt_time);
    setData_modalTS_ot_time(ot_time);
  }

  //#endregion

  //#region __ carousel  __
  function onclicknext(next, goToSlide, currentSlide, cntck) {
    if (issearch === 1) {
      // จากปุ่ม Search เราจะ เลื่อนได้อย่างเดียว ไม่ดึงข้อมูลเพิ่ม
      next();
    } else {
      let ck_next = nowSlide + checknextSlide - (cntck === 10 ? 0 : 5);
      if (nextSlide <= ck_next) {
        setIsLoadProgress(true);
        let wb = ck_next;
        BindlistweekbarBar(
          wb.toString(),
          _slidesToslide.toString(),
          "next",
          function () {
            setNowSlide(
              nowSlide + _slidesToslide === 0 ? 1 : nowSlide + _slidesToslide
            );
            setNextSlide(nextSlide + _slidesToslide);
            goToSlide(currentSlide + _slidesToslide);
            setIsLoadProgress(false);
          }
        );
      } else {
        setNowSlide(
          nowSlide + _slidesToslide === 0 ? 1 : nowSlide + _slidesToslide
        );
        next();
      }
    }
  }

  function onclickGotoSet(goToSlide) {
    let indexGoto = 0;
    try {
      indexGoto = parseInt(document.getElementById("hd_Slideindex_Goto").value);
    } catch {
      indexGoto = 0;
    }
    goToSlide(indexGoto);
  }

  function onclickprevious(previous, currentSlide) {
    if (issearch === 1) {
      // จากปุ่ม Search เราจะ เลื่อนได้อย่างเดียว ไม่ดึงข้อมูลเพิ่ม
      previous();
    } else {
      if (currentSlide <= 0) {
        setIsLoadProgress(true);
        BindlistweekbarBar(
          previousSlide.toString(),
          _slidesToslide.toString(),
          "previous",
          function () {
            setPreviousSlide(previousSlide + _slidesToslide * -1);
            setNowSlide(
              nowSlide - _slidesToslide === 1 - _slidesToslide
                ? _slidesToslide * -1
                : nowSlide - _slidesToslide
            );
            previous();
            setIsLoadProgress(false);
          }
        );
      } else {
        setNowSlide(
          nowSlide - _slidesToslide === 1 - _slidesToslide
            ? _slidesToslide * -1
            : nowSlide - _slidesToslide
        );
        previous();
      }
    }
  }

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide, deviceType },
    } = rest;
    const cntck =
      deviceType === "desktop"
        ? itemsdesktop
        : deviceType === "tablet"
        ? itemstablet
        : itemsmobile;
    return (
      ((issearch === 1 && listweekbar.length > 0) || issearch === 0) && (
        <>
          {((issearch === 1 && currentSlide !== 0) || issearch === 0) && (
            <button
              className="carousel-control-prev"
              onClick={() => onclickprevious(previous, currentSlide)}
            >
              <i className="fa fa-angle-left" />
            </button>
          )}
          {((issearch === 1 && currentSlide < listweekbar.length - cntck) ||
            issearch === 0) && (
            <button
              className="carousel-control-next "
              onClick={() => onclicknext(next, goToSlide, currentSlide, cntck)}
            >
              <i className="fa fa-angle-right" />
            </button>
          )}
          <button
            id="btn_GotoSet"
            style={{ display: "none" }}
            onClick={() => onclickGotoSet(goToSlide)}
          >
            <i className="fa fa-angle-right" />
          </button>
        </>
      )
    );
  };

  const responsive = {
    desktop: {
      breakpoint: { max: desktopmax, min: tabletmax },
      items: itemsdesktop,
      partialVisibilityGutter: 15,
    },
    tablet: {
      breakpoint: { max: tabletmax, min: mobilemax },
      items: itemstablet,
      partialVisibilityGutter: 15,
    },
    mobile: {
      breakpoint: { max: mobilemax, min: 0 },
      items: itemsmobile,
      partialVisibilityGutter: 15,
    },
  };
  //#endregion

  return (
    <>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      <div className="content-header">
        
          <div className="row">

            <div className= {isReport=== 0 ? "col-lg-9 col-sm-12 col-12" :"col-lg-10 col-sm-12 col-12"} >
                <div className="text-center">

                {
                  (isReport === 0 &&
                      <>
                      {" "}
                      <h6> </h6>
                    </>
                  ) ||
                  (
                    <>

                    <div className="container-fluid">
                      <h1 className=" display-5"> Timesheet report</h1>
                      <h6>Timesheet By Staff </h6>
                    </div>

                    </>
                  )
                }



                
                </div>
            </div>
            <div className={isReport=== 0 ? "col-lg-3 col-sm-12 col-12" :"col-lg-2 col-sm-12 col-12"} >
                <div className="float-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={onclick_refresh}
                  >
                    <i className="fas fa-sync-alt" /> Refresh
                  </button>
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-toggle="collapse"
                    href="#collapse_tsbstaff"
                  >
                    <i
                      className={
                        isReport === 0 ? "fas fa-filter" : "fas fa-filter"
                      }
                    />{" "}
                    {isReport === 0 ? "Filter" : "Filter"}
                  </button>
                </div>
            </div>
          </div>
         
          {/* ###################### Search ###################### */}
          <div
            className={
              isReport === 0 ? "row mt-4 table-bordered bg-light" : "row mt-2"
            }
            id="accordionTSByStaff"
          >
            <div className="col-md-10 offset-md-1">
              <div>
                <div
                  className="collapse show"
                  id="collapse_tsbstaff"
                  data-parent="#accordionTSByStaff"
                >
                  <div 
                   className={
                    isReport === 0 ? "row mt-2" : "row mt-0"}
                  >
                    <div className="col-lg-10 col-12 text-center">
                      <div className="form-group ">
                        <label className="text-small text-normal pr-2 m-0 ">
                          View time by
                        </label>
                        <div className="icheck-primary d-inline">
                          <input
                            type="radio"
                            id="rdo_TSbyStaff_View_wt"
                            name="rdo_TSbyStaff_View"
                            value="wt"
                            checked={selectedViewtime === "wt"}
                            onChange={handleRadioViewtimeChange}
                          />
                          <label
                            htmlFor="rdo_TSbyStaff_View_wt"
                            className="pr-3"
                          >
                            <span className="pl-0">work time</span>
                          </label>
                        </div>

                        {isSVOT &&
                          <div className="icheck-primary d-inline">
                            <input
                              type="radio"
                              id="rdo_TSbyStaff_View_ot"
                              name="rdo_TSbyStaff_View"
                              value="ot"
                              checked={selectedViewtime === "ot"}
                              onChange={handleRadioViewtimeChange}
                            />
                            <label
                              htmlFor="rdo_TSbyStaff_View_ot"
                              className="pr-3"
                            >
                              <span className="pl-0">over time</span>
                            </label>
                          </div>
                        }


                        <div className="icheck-primary d-inline">
                          <input
                            type="radio"
                            id="rdo_TSbyStaff_View_tof"
                            name="rdo_TSbyStaff_View"
                            value="tof"
                            checked={selectedViewtime === "tof"}
                            onChange={handleRadioViewtimeChange}
                          />
                          <label
                            htmlFor="rdo_TSbyStaff_View_tof"
                            className="pr-3"
                          >
                            <span className="pl-0">time off</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>





                  <div className="row m-0">

                    
                    <div className={isReport === 1  ? "col-lg-4 col-12" : "col-lg-4 col-12"}>
                        
                      <div className="form-group m-0">
                        <label className="text-small p-0 m-0">Date</label>
                        <div className="input-group">
                          <DateRangePickerComponent
                          style={date_pickerStyle}
                            id="txt_SearchDate_TSbyStaff"
                            format="dd/MM/yyyy"
                            presets={dataPresets}
                            strictMode={true}
                          ></DateRangePickerComponent>
                        </div>
                      </div>
                    </div>

                    {isReport === 1 && (
                      <>
                        <div className="col-lg-4 col-12">
                          <div className="form-group">
                            <label className="text-small p-0 m-0">Customer</label>
                            {isLoadedConfigData && (
                              <SelectCustomer
                                API_URL={configData.API_URL}
                                cus_status={"-1"}
                                selectismulti={false}
                                SelectTextDefault={ConfigETC.ddl_All}
                                resetSelect={iscntreset}
                                onChangevalue={SearchonChangevalueCus}
                                iscloseMenuOnSelect={true}
                              ></SelectCustomer>
                            )}
                          </div>
                          <input type="hidden" id="hd_cus_id_search" ></input>
                        </div>

                        <div className="col-lg-4 col-12">
                          <div className="form-group">
                            <label className="text-small p-0 m-0">
                              Project
                            </label>
                            {isLoadedConfigData && (
                              <SelectProjectByTimeSheetBySearch
                                API_URL={configData.API_URL}
                                pro_status={"-1"}
                                staff_status={"-1"}
                                selectismulti={true}
                                SelectTextDefault={ConfigETC.ddl_All}
                                resetSelect={iscntreset}
                                onChangevalue={SearchonChangevalueproject}
                                iscloseMenuOnSelect={false}
                              
                                BindProjectBycusid={bindProjectBycusid}
                                hd_cus_id={"hd_cus_id_search"}
                                Bindendfunction={Bindendfunction_SP}
                                
                              ></SelectProjectByTimeSheetBySearch>
                            )}
                          </div>
                        </div>

                      </>
                    )}

                  </div>

                  <div className="row m-0">
                    <div className="col-lg-4 col-12">
                      <div className="form-group">
                        <label className="text-small p-0 m-0">Staffs</label>
                        {isLoadedConfigData && isReport === 1 && (
                          <SelectStaff
                            API_URL={configData.API_URL}
                            staff_status={"-1"}
                            selectismulti={true}
                            SelectTextDefault={ConfigETC.ddl_All}
                            resetSelect={iscntreset}
                            onChangevalue={SearchonChangevaluestaff}
                            iscloseMenuOnSelect={false}
                          ></SelectStaff>
                        )}
                        {isLoadedConfigData && isReport === 0 && (
                          <SelectStaffByProject
                            API_URL={configData.API_URL}
                            staff_status={"-1"}
                            project_id={Pro_id}
                            selectismulti={true}
                            SelectTextDefault={ConfigETC.ddl_All}
                            resetSelect={iscntreset}
                            onChangevalue={SearchonChangevaluestaff}
                            iscloseMenuOnSelect={false}
                          ></SelectStaffByProject>
                        )}
                      </div>
                    </div>
                    {(isReport === 1 && (
                      <>
                       
                      </>
                    )) ||
                    (
                      <>
                         <div className="col-lg-4 col-12">
                          <div className="form-group">
                            <label className="text-small p-0 m-0">Tasks</label>
                            {isLoadedConfigData && (
                              <SelectTaskMultiGroup
                                API_URL={configData.API_URL}
                                SelectTextDefault={ConfigETC.ddl_All}
                                resetSelect={iscntreset}
                                resetSelect2={iscntresetTask}
                                onChangevalue={SearchonChangevalueTask}
                                iscloseMenuOnSelect={false}
                                isDisabled={isselectTask}
                              ></SelectTaskMultiGroup>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                   
                    
                   
                    
                    {isReport === 1 && (
                      <>
                        <div className="col-lg-4 col-12">
                          <div className="form-group">
                            <label className="text-small p-0 m-0">Task</label>
                            {isLoadedConfigData && (
                              <SelectTaskMultiGroup
                                API_URL={configData.API_URL}
                                SelectTextDefault={ConfigETC.ddl_All}
                                resetSelect={iscntreset}
                                resetSelect2={iscntresetTask}
                                onChangevalue={SearchonChangevalueTask}
                                iscloseMenuOnSelect={false}
                                isDisabled={isselectTask}
                              ></SelectTaskMultiGroup>
                            )}
                          </div>
                        </div>
                      </>
                      )}
                    
                    <div className="col-lg-4 col-6">
                      <div className="form-group m-0">
                        <label className="text-small p-0 m-0">Status</label>
                        <Select
                          placeholder={ConfigETC.ddl_All}
                          value={searchstatus}
                          components={animatedComponents}
                          isClearable={true}
                          closeMenuOnSelect={false}
                          isMulti={true}
                          options={Bind_Select_Status("PVTimesheetbyStaff")}
                          menuPortalTarget={document.body}
                          onChange={SearchonChangevalueStatus}
                          styles={customStylesSelect}
                        />
                      </div>


                    </div>

                    <div className="col-lg-4 col-6">
                      <div className="form-group">
                        <label className="text-small p-0 m-0">Time off</label>
                        {isLoadedConfigData && (
                          <SelectTimeoff
                            API_URL={configData.API_URL}
                            timeoff_status={"-1"}
                            selectismulti={true}
                            SelectTextDefault={ConfigETC.ddl_All}
                            resetSelect={iscntreset}
                            resetSelect2={iscntresettimeoff}
                            onChangevalue={SearchonChangevaluetimeoff}
                            iscloseMenuOnSelect={false}
                            isDisabled={isselectTimeoff}
                          ></SelectTimeoff>
                        )}
                      </div>
                    </div>

                    
                    <div className="col-lg-4 col-6">
                      <div className="form-group">
                      <label className="text-small p-0 m-0">&nbsp;</label>
                            <br></br>
                        <span className="icheck-primary d-inline">
                          <input
                            id="chk_show_all"
                            type="checkbox"
                            className="form-check-input"
                            checked={searchShowAll}
                            onChange={onChange_CBAll}
                          />
                          <label
                            htmlFor="chk_show_all"
                            className="text-small p-0 m-0"
                          >
                            Show all (staffs status)
                          </label>
                        </span>
                      </div>
                    </div>
                    
                    <div className="card-tools">
                    {isReport === 0 && (
                      <>
                        <div className="col-lg-12 col-12">
                          <div className="form-group m-0">
                            <label className="text-small p-0 m-0" />
                            <div className="card-tools">
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={onclick_search}
                              >
                                <i className="fas fa-search" /> Search
                              </button>{" "}
                              {listweekbar.length > 0 && (
                                <>
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={(e)=>onclick_ReportType_Print("excel")}
                                >
                                  <i className="fa fa-file-excel fa-lg" /> Excel
                                </button>{" "}
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={(e)=>onclick_ReportType_Print("pdf")}
                                >
                                  <i className="fa fa-file-pdf fa-lg" /> PDF
                                </button>
                                </>
                              )}      
                            </div>
                          </div>
                        </div>
                      </>
                      )}

                        
                      </div>

                  </div> 

                  {isReport === 1 && (
                    <>
                      <div className="row m-0">
                        <div className="col-lg-12 col-12 text-center">
                          <div className="form-group m-0">
                            {/* <label className="text-small p-0 m-0" /> */}
                            <div className="card-tools">
                              <button
                                type="button"
                                className="btn btn-primary "
                                onClick={onclick_search}
                              >
                                <i className="fas fa-search" /> Search
                              </button>{" "}
                              {listweekbar.length > 0 && (
                                <>
                                <button
                                  type="button"
                                  className="btn btn-primary "
                                  onClick={(e)=>onclick_ReportType_Print("excel")}
                                >
                                <i className="fa fa-file-excel fa-lg" /> Excel
                                </button>{" "}
                                <button
                                  type="button"
                                  className="btn btn-primary "
                                  onClick={(e)=>onclick_ReportType_Print("pdf")}
                                >
                                <i className="fa fa-file-pdf fa-lg" /> PDF
                                </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                    )}


                </div>
              </div>
            </div>
          </div>
          {/* ###################### Search ###################### */}

          <input type="hidden" id="hd_Slideindex_Goto"></input>
          {
            <>
              <div className="row mt-2">
                <div className="col-md-12">
                  <div className="MultiCarousel card mb-0">
                    <Carousel
                      responsive={responsive}
                      arrows={false}
                      draggable={false}
                      keyBoardControl={false}
                      additionalTransfrom={0}
                      slidesToSlide={_slidesToslide}
                      renderButtonGroupOutside
                      customButtonGroup={<ButtonGroup />}
                    >
                      {listweekbar.map((en, index) => (
                        <div
                          key={"div_barweek" + index.toString()}
                          className="item"
                        >
                          <div className="page-item ">
                            <a
                              href="#!"
                              className={
                                en.uniqueid === calendaractive
                                  ? "page-link active"
                                  : "page-link"
                              }
                              data-toggle="pill"
                              onClick={() =>
                                onclick_viewProject(
                                  en.date_Start,
                                  en.uniqueid,
                                  en.isholiday_sun,
                                  en.isholiday_mon,
                                  en.isholiday_tue,
                                  en.isholiday_wed,
                                  en.isholiday_thu,
                                  en.isholiday_fri,
                                  en.isholiday_sat,
                                  en.dt_date_sun,
                                  en.dt_date_mon,
                                  en.dt_date_tue,
                                  en.dt_date_wed,
                                  en.dt_date_thu,
                                  en.dt_date_fri,
                                  en.dt_date_sat
                                  , en.dt_Full_sun
                                  , en.dt_Full_mon
                                  , en.dt_Full_tue
                                  , en.dt_Full_wed
                                  , en.dt_Full_thu
                                  , en.dt_Full_fri
                                  , en.dt_Full_sat
                                  , en.dayShow
                                  , en.monthShow
                                )
                              }
                            >
                              <div>{en.dayShow}</div>
                              <div className="text-bold">{en.monthShow}</div>
                              <div className="week-icon"></div>
                            </a>
                          </div>
                        </div>
                      ))}
                    </Carousel>
                  </div>
                </div>
              </div>
            </>
          }
          {listweekbar.length === 0 && (
            <>
              <div className="row mt-2">
                <div className="col-md-12">
                  <div className="card  shadow">
                    <div className="card-body p-0">
                      <table className="table table-head-fixed text-nowrap table-hover">
                        <tbody>
                          <tr>
                            <td align="center">{ConfigETC.NoData}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card shadow">
                <input type="hidden" id="hdCBP_dt_sun"></input>
                <input type="hidden" id="hdCBP_dt_mon"></input>
                <input type="hidden" id="hdCBP_dt_tue"></input>
                <input type="hidden" id="hdCBP_dt_wed"></input>
                <input type="hidden" id="hdCBP_dt_thu"></input>
                <input type="hidden" id="hdCBP_dt_fri"></input>
                <input type="hidden" id="hdCBP_dt_sat"></input>

                {/* ###################### Calendar By Project By Day ###################### */}
                {isshowDetailTs && (
                  <>
                    <div className="card-body table-responsive p-0">
                      <TableContainer sx={{ maxHeight: 500 }}>
                        <Table
                          stickyHeader
                          aria-label="sticky table"
                          className="table table-head-fixed text-sm table-fit"
                          style={{ margin: 0 }}
                          border={0}
                        >
                          <TableHead>
                            <TableRow className="card-footer">
                              <TableCell
                                className="align-top"
                                style={{ width: "10px" }}
                              ></TableCell>
                              <TableCell
                                className="align-bottom"
                                style={{ width: "180px" }}
                              ></TableCell>
                              <TableCell
                                className="align-top"
                                style={{ width: "240px" }}
                              />
                              <TableCell
                                className={
                                  "text-center-input align-top " +
                                  (isholiday_sun === "y" ? "bg-light" : "")
                                }
                                style={{ width: "140px" }}
                              >
                                <div className="text-bold">SUN</div>
                                <div className="text-normal">
                                  <span id="span_day_sun"></span>
                                  <IconTodayShoworNot
                                    isshow={icontoday === "sun" ? "show" : ""}
                                  ></IconTodayShoworNot>
                                </div>
                              </TableCell>
                              <TableCell
                                className={
                                  isholiday_mon === "y" ? h_holi : h_nholi
                                }
                                style={{ width: "140px" }}
                              >
                                <div className="text-bold">MON</div>
                                <div className="text-normal">
                                  <span id="span_day_mon"></span>
                                  <IconTodayShoworNot
                                    isshow={icontoday === "mon" ? "show" : ""}
                                  ></IconTodayShoworNot>
                                </div>
                              </TableCell>
                              <TableCell
                                className={
                                  isholiday_tue === "y" ? h_holi : h_nholi
                                }
                                style={{ width: "140px" }}
                              >
                                <div className="text-bold">TUE</div>
                                <div className="text-normal">
                                  <span id="span_day_tue"></span>
                                  <IconTodayShoworNot
                                    isshow={icontoday === "tue" ? "show" : ""}
                                  ></IconTodayShoworNot>
                                </div>
                              </TableCell>
                              <TableCell
                                className={
                                  isholiday_wed === "y" ? h_holi : h_nholi
                                }
                                style={{ width: "140px" }}
                              >
                                <div className="text-bold">WED</div>
                                <div className="text-normal">
                                  <span id="span_day_wed"></span>
                                  <IconTodayShoworNot
                                    isshow={icontoday === "wed" ? "show" : ""}
                                  ></IconTodayShoworNot>
                                </div>
                              </TableCell>
                              <TableCell
                                className={
                                  isholiday_thu === "y" ? h_holi : h_nholi
                                }
                                style={{ width: "140px" }}
                              >
                                <div className="text-bold"> THU</div>
                                <div className="text-normal">
                                  <span id="span_day_thu"></span>
                                  <IconTodayShoworNot
                                    isshow={icontoday === "thu" ? "show" : ""}
                                  ></IconTodayShoworNot>
                                </div>
                              </TableCell>
                              <TableCell
                                className={
                                  isholiday_fri === "y" ? h_holi : h_nholi
                                }
                                style={{ width: "140px" }}
                              >
                                <div className="text-bold">FRI </div>
                                <div className="text-normal">
                                  <span id="span_day_fri"></span>
                                  <IconTodayShoworNot
                                    isshow={icontoday === "fri" ? "show" : ""}
                                  ></IconTodayShoworNot>
                                </div>
                              </TableCell>
                              <TableCell
                                className={
                                  isholiday_sat === "y" ? h_holi : h_nholi
                                }
                                style={{ width: "140px" }}
                              >
                                <div className="text-bold">SAT</div>
                                <div className="text-normal">
                                  <span id="span_day_sat"></span>
                                  <IconTodayShoworNot
                                    isshow={icontoday === "sat" ? "show" : ""}
                                  ></IconTodayShoworNot>
                                </div>
                              </TableCell>
                              <TableCell
                                className="align-items-center text-muted"
                                style={{ width: "140px" }}
                              >
                                Total
                              </TableCell>
                            </TableRow>
                          </TableHead>


                          {(act_ShowDetail === 1 && 
                            <>
                              <TableBody>
                                {(listDetailTS.length === 0 && (
                                  <TableRow key={1}>
                                    <TableCell colSpan={11} align="center">
                                      {ConfigETC.NoData}
                                    </TableCell>
                                  </TableRow>
                                )) ||
                                  listDetailTS.map((row, index) => (
                                    <TableRow key={"tr_" + row.rowindex.toString()}>
                                      <TableCell>{index + 1}</TableCell>
                                      <TableCell colSpan={2} className="text-left" style={{width:410+ 'pt'}}>
                                        <div>
                                          {""}
                                          <a
                                            href="#!"
                                            onClick={() => onclick_showdetailstaff(row.staff_code , row.fullName)}
                                            data-toggle="pill"
                                            className="text-bold text-black"
                                            rel="noopener noreferrer"
                                          >
                                            <span className="btn btn-primary btn-xs">
                                              <i className="fas fa-user" 
                                              title="Click for view detail"/>
                                            </span>
                                          </a>{" "}
                                          {row.fullName}
                                        </div>
                                      </TableCell>

                                      <TableCell
                                        className={
                                          isholiday_sun === "y" ? b_holi : b_nholi
                                        }
                                        align="center"
                                      >
                                        <div>{row.sum_time_sun}</div>
                                      </TableCell>
                                      <TableCell
                                        className={
                                          isholiday_mon === "y" ? b_holi : b_nholi
                                        }
                                        align="center"
                                      >
                                        <div>{row.sum_time_mon}</div>
                                      </TableCell>
                                      <TableCell
                                        className={
                                          isholiday_tue === "y" ? b_holi : b_nholi
                                        }
                                        align="center"
                                      >
                                        <div>{row.sum_time_tue}</div>
                                      </TableCell>
                                      <TableCell
                                        className={
                                          isholiday_wed === "y" ? b_holi : b_nholi
                                        }
                                        align="center"
                                      >
                                        <div>{row.sum_time_wed}</div>
                                      </TableCell>
                                      <TableCell
                                        className={
                                          isholiday_thu === "y" ? b_holi : b_nholi
                                        }
                                        align="center"
                                      >
                                        <div>{row.sum_time_thu}</div>
                                      </TableCell>
                                      <TableCell
                                        className={
                                          isholiday_fri === "y" ? b_holi : b_nholi
                                        }
                                        align="center"
                                      >
                                        <div>{row.sum_time_fri}</div>
                                      </TableCell>
                                      <TableCell
                                        className={
                                          isholiday_sat === "y" ? b_holi : b_nholi
                                        }
                                        align="center"
                                      >
                                        <div>{row.sum_time_sat}</div>
                                      </TableCell>
                                      <TableCell align="center">
                                        <div className="text-bold text-muted">
                                          <ShowTimehrmm
                                            timehr={row.total_allweekbystaff_hr}
                                            timemm={row.total_allweekbystaff_mm}
                                          ></ShowTimehrmm>
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>  
                            </>
                            )
                            ||
                            (
                              <>
                                <TableBody>
                                  <TableRow key={"tr_0"}>
                                    <TableCell colSpan={11} align="left">
                                      <span className="pull-left">
                                      <h6 className="text-bold">
                                        <a
                                          href="#!"
                                          onClick={() => onclick_showdetailAll()}
                                          data-toggle="pill"
                                          className="text-bold text-black"
                                          rel="noopener noreferrer"
                                          title="Back to all staffs"
                                        >
                                          <span className="btn btn-default btn-xs">
                                            <i className="fas fa-arrow-left" /> back
                                          </span>
                                        </a>{" "}
                                        <i className="fas fa-user" /> {valuestaffname_detail}</h6>
                                      </span>
                                     
                                    </TableCell>
                                  </TableRow>
                                  {(listDetailTSWStaff.length === 0 && (
                                    <TableRow key={1}>
                                      <TableCell colSpan={11} align="center">
                                        {ConfigETC.NoData}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                  {(listDetailTSWStaff.map((row, index) => (
                                      <TableRow key={"tr_" + row.rowindex.toString()}>
                                        <TableCell>{index + 1}</TableCell>
                                        
                                        <TableCell  className="text-left" style={{width:150 + 'px'}}>
                                          <div>{row.project_name}</div>
                                        </TableCell>
                                        <TableCell  className="text-left" style={{width:220 + 'px'}} >
                                          {row.act_task_timeoff === "T" &&
                                            <div>
                                              {row.taskname + "/" + row.tasksubname}
                                            </div>
                                          } 
                                          {row.act_task_timeoff === "TO" &&
                                            <div>
                                              <span className="text-italic text-muted">Time Off:</span> {row.timeoff_name}
                                            </div>
                                          }
                                        </TableCell>

                                        <TableCell
                                          className={
                                            isholiday_sun === "y" ? b_holi : b_nholi
                                          }
                                          align="center"
                                        >
                                          <CellDayProject 
                                            tsid={row.tsid_sun} 
                                            day={"Sun"}
                                            dt_dayFull={dt_Full_sun} 
                                            wt_time={row.wt_time_sun}
                                            tss={row.tss_sun}
                                            tte={row.tte_sun}
                                            ActProject={row.actproject_sun}
                                            project_name={row.project_name}
                                            act_task_timeoff={row.act_task_timeoff}
                                            onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                            customer_name={row.customer_name}
                                            taskname={row.taskname}
                                            tasksubname={row.tasksubname}
                                            timeoff_name={row.timeoff_name}
                                            pos_name={row.pos_name_sun}
                                            ee={row.ee_sun}
                                            et={row.et_sun}
                                            eo={row.eo_sun}
                                            eed={row.eed_sun}
                                            etd={row.etd_sun}
                                            desc={row.desc_sun}
                                            tsssn={row.tsssn_sun}
                                            tsrd={row.tsrd_sun}
                                            ud={row.ud_sun}
                                            usn={row.usn_sun}
                                            tsd={row.tsd_sun}
                                            ot_time={row.ot_time_sun}
                                            holiday={isholiday_sun}     
                                            isSVOT={isSVOT}
                                            >
                                          </CellDayProject>
                                        </TableCell>
                                        <TableCell
                                          className={
                                            isholiday_mon === "y" ? b_holi : b_nholi
                                          }
                                          align="center"
                                        >
                                          <CellDayProject 
                                            tsid={row.tsid_mon} 
                                            day={"Mon"} 
                                            dt_dayFull={dt_Full_mon} 
                                            wt_time={row.wt_time_mon}
                                            tss={row.tss_mon}
                                            tte={row.tte_mon}
                                            ActProject={row.actproject_mon}
                                            project_name={row.project_name}
                                            act_task_timeoff={row.act_task_timeoff}
                                            onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                            customer_name={row.customer_name}
                                            taskname={row.taskname}
                                            tasksubname={row.tasksubname}
                                            timeoff_name={row.timeoff_name}
                                            pos_name={row.pos_name_mon}
                                            ee={row.ee_mon}
                                            et={row.et_mon}
                                            eo={row.eo_mon}
                                            eed={row.eed_mon}
                                            etd={row.etd_mon}
                                            desc={row.desc_mon}
                                            tsssn={row.tsssn_mon}
                                            tsrd={row.tsrd_mon}
                                            ud={row.ud_mon}
                                            usn={row.usn_mon}
                                            tsd={row.tsd_mon}
                                            ot_time={row.ot_time_mon}
                                            holiday={isholiday_mon}    
                                            isSVOT={isSVOT}      
                                            >
                                          </CellDayProject>
                                        </TableCell>
                                        <TableCell
                                          className={
                                            isholiday_tue === "y" ? b_holi : b_nholi
                                          }
                                          align="center"
                                        >
                                          <CellDayProject 
                                          tsid={row.tsid_tue} 
                                          day={"Tue"} 
                                          dt_dayFull={dt_Full_tue} 
                                          wt_time={row.wt_time_tue}
                                          tss={row.tss_tue}
                                          tte={row.tte_tue}
                                          ActProject={row.actproject_tue}
                                          project_name={row.project_name}
                                          act_task_timeoff={row.act_task_timeoff}
                                          onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                          customer_name={row.customer_name}
                                          taskname={row.taskname}
                                          tasksubname={row.tasksubname}
                                          timeoff_name={row.timeoff_name}
                                          pos_name={row.pos_name_tue}
                                          ee={row.ee_tue}
                                          et={row.et_tue}
                                          eo={row.eo_tue}
                                          eed={row.eed_tue}
                                          etd={row.etd_tue}
                                          desc={row.desc_tue}
                                          tsssn={row.tsssn_tue}
                                          tsrd={row.tsrd_tue}
                                          ud={row.ud_tue}
                                          usn={row.usn_tue}
                                          tsd={row.tsd_tue}
                                          ot_time={row.ot_time_tue}
                                          holiday={isholiday_tue}     
                                          isSVOT={isSVOT}
                                          >
                                          </CellDayProject>
                                        </TableCell>
                                        <TableCell
                                          className={
                                            isholiday_wed === "y" ? b_holi : b_nholi
                                          }
                                          align="center"
                                        >
                                          <CellDayProject 
                                            tsid={row.tsid_wed} 
                                            day={"Wed"} 
                                            dt_dayFull={dt_Full_wed} 
                                            wt_time={row.wt_time_wed}
                                            tss={row.tss_wed}
                                            tte={row.tte_wed}
                                            ActProject={row.actproject_wed}
                                            project_name={row.project_name}
                                            act_task_timeoff={row.act_task_timeoff}
                                            onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                            customer_name={row.customer_name}
                                            taskname={row.taskname}
                                            tasksubname={row.tasksubname}
                                            timeoff_name={row.timeoff_name}
                                            pos_name={row.pos_name_wed}
                                            ee={row.ee_wed}
                                            et={row.et_wed}
                                            eo={row.eo_wed}
                                            eed={row.eed_wed}
                                            etd={row.etd_wed}
                                            desc={row.desc_wed}
                                            tsssn={row.tsssn_wed}
                                            tsrd={row.tsrd_wed}
                                            ud={row.ud_wed}
                                            usn={row.usn_wed}
                                            tsd={row.tsd_wed}
                                            ot_time={row.ot_time_wed}
                                            holiday={isholiday_wed}    
                                            isSVOT={isSVOT}        
                                            >
                                          </CellDayProject>
                                        </TableCell>
                                        <TableCell
                                          className={
                                            isholiday_thu === "y" ? b_holi : b_nholi
                                          }
                                          align="center"
                                        >
                                          <CellDayProject 
                                            tsid={row.tsid_thu} 
                                            day={"Thu"} 
                                            dt_dayFull={dt_Full_thu} 
                                            wt_time={row.wt_time_thu}
                                            tss={row.tss_thu}
                                            tte={row.tte_thu}
                                            ActProject={row.actproject_thu}
                                            project_name={row.project_name}
                                            act_task_timeoff={row.act_task_timeoff}
                                            onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                            customer_name={row.customer_name}
                                            taskname={row.taskname}
                                            tasksubname={row.tasksubname}
                                            timeoff_name={row.timeoff_name}
                                            pos_name={row.pos_name_thu}
                                            ee={row.ee_thu}
                                            et={row.et_thu}
                                            eo={row.eo_thu}
                                            eed={row.eed_thu}
                                            etd={row.etd_thu}
                                            desc={row.desc_thu}
                                            tsssn={row.tsssn_thu}
                                            tsrd={row.tsrd_thu}
                                            ud={row.ud_thu}
                                            usn={row.usn_thu}
                                            tsd={row.tsd_thu}
                                            ot_time={row.ot_time_thu}
                                            holiday={isholiday_thu}   
                                            isSVOT={isSVOT}     
                                            >
                                          </CellDayProject>
                                        </TableCell>
                                        <TableCell
                                          className={
                                            isholiday_fri === "y" ? b_holi : b_nholi
                                          }
                                          align="center"
                                        >
                                          <CellDayProject 
                                            tsid={row.tsid_fri} 
                                            day={"Fri"} 
                                            dt_dayFull={dt_Full_fri} 
                                            wt_time={row.wt_time_fri}
                                            tss={row.tss_fri}
                                            tte={row.tte_fri}
                                            ActProject={row.actproject_fri}
                                            project_name={row.project_name}
                                            act_task_timeoff={row.act_task_timeoff}
                                            onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                            customer_name={row.customer_name}
                                            taskname={row.taskname}
                                            tasksubname={row.tasksubname}
                                            timeoff_name={row.timeoff_name}
                                            pos_name={row.pos_name_fri}
                                            ee={row.ee_fri}
                                            et={row.et_fri}
                                            eo={row.eo_fri}
                                            eed={row.eed_fri}
                                            etd={row.etd_fri}
                                            desc={row.desc_fri}
                                            tsssn={row.tsssn_fri}
                                            tsrd={row.tsrd_fri}
                                            ud={row.ud_fri}
                                            usn={row.usn_fri}
                                            tsd={row.tsd_fri}
                                            ot_time={row.ot_time_fri}
                                            holiday={isholiday_fri} 
                                            isSVOT={isSVOT}    
                                            >
                                          </CellDayProject>
                                        </TableCell>
                                        <TableCell
                                          className={
                                            isholiday_sat === "y" ? b_holi : b_nholi
                                          }
                                          align="center"
                                        >
                                          <CellDayProject 
                                            tsid={row.tsid_sat} 
                                            day={"Sat"} 
                                            dt_dayFull={dt_Full_sat} 
                                            wt_time={row.wt_time_sat}
                                            tss={row.tss_sat}
                                            tte={row.tte_sat}
                                            ActProject={row.actproject_sat}
                                            project_name={row.project_name}
                                            act_task_timeoff={row.act_task_timeoff}
                                            onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                            customer_name={row.customer_name}
                                            taskname={row.taskname}
                                            tasksubname={row.tasksubname}
                                            timeoff_name={row.timeoff_name}
                                            pos_name={row.pos_name_sat}
                                            ee={row.ee_sat}
                                            et={row.et_sat}
                                            eo={row.eo_sat}
                                            eed={row.eed_sat}
                                            etd={row.etd_sat}
                                            desc={row.desc_sat}
                                            tsssn={row.tsssn_sat}
                                            tsrd={row.tsrd_sat}
                                            ud={row.ud_sat}
                                            usn={row.usn_sat}
                                            tsd={row.tsd_sat}
                                            ot_time={row.ot_time_sat}
                                            holiday={isholiday_sat}   
                                            isSVOT={isSVOT}         
                                            >
                                          </CellDayProject>
                                        </TableCell>
                                        <TableCell align="center">
                                          <div className="text-bold text-muted">
                                            <ShowTimehrmm
                                              timehr={row.total_allweekbystaff_hr}
                                              timemm={row.total_allweekbystaff_mm}
                                            ></ShowTimehrmm>
                                          </div>
                                        </TableCell>
                                      </TableRow>
                                    )))
                                  }
                                </TableBody>
                              
                              </>
                            )
                          }   




                        </Table>
                      </TableContainer>
                    </div>

                    {/* ###################### Footer ###################### */}
                    <div className="card-body p-0">
                      <table
                        className="table table-head-fixed text-sm  table-fit"
                        style={{ margin: 0 }}
                        border={0}
                      >
                        <tfoot>
                          <tr className="card-footer">
                            <td style={{ width: "5px" }}>
                              {" "}
                              <div> &nbsp;&nbsp;&nbsp;</div>
                            </td>
                            <td style={{ width: "150px" }}>
                              <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            </td>
                            <td style={{ width: "274px" }}>
                              <div className="text-right text-muted pr-1">
                                <div>
                                  
                                 <b> Total </b>
                                </div>
                              </div>
                            </td>
                            <td  className="text-bold" style={{ width: "133px" }} align="center">
                              <ShowTimehrmm
                                timehr={total_allday_sun_hr}
                                timemm={total_allday_sun_mm}
                              ></ShowTimehrmm>
                            </td>
                            <td className="text-bold" style={{ width: "133px" }} align="center">
                              <ShowTimehrmm
                                timehr={total_allday_mon_hr}
                                timemm={total_allday_mon_mm}
                              ></ShowTimehrmm>
                            </td>
                            <td className="text-bold" style={{ width: "133px" }} align="center">
                              <ShowTimehrmm
                                timehr={total_allday_tue_hr}
                                timemm={total_allday_tue_mm}
                              ></ShowTimehrmm>
                            </td>
                            <td className="text-bold" style={{ width: "133px" }} align="center">
                              <ShowTimehrmm
                                timehr={total_allday_wed_hr}
                                timemm={total_allday_wed_mm}
                              ></ShowTimehrmm>
                            </td>
                            <td className="text-bold" style={{ width: "133px" }} align="center">
                              <ShowTimehrmm
                                timehr={total_allday_thu_hr}
                                timemm={total_allday_thu_mm}
                              ></ShowTimehrmm>
                            </td>
                            <td className="text-bold" style={{ width: "133px" }} align="center">
                              <ShowTimehrmm
                                timehr={total_allday_fri_hr}
                                timemm={total_allday_fri_mm}
                              ></ShowTimehrmm>
                            </td>
                            <td
                              style={{ width: "133px" }}
                              className="text-bold bg-light"
                              align="center"
                            >
                              <ShowTimehrmm
                                timehr={total_allday_sat_hr}
                                timemm={total_allday_sat_mm}
                              ></ShowTimehrmm>
                            </td>
                            <td className="text-bold"style={{ width: "135px" }} align="center">
                              <ShowTimehrmm
                                timehr={total_allday_allweek_hr}
                                timemm={total_allday_allweek_mm}
                              ></ShowTimehrmm>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    {/* ###################### Footer ###################### */}
                  </>
                )}
                {/* ###################### Calendar By Project By Day ###################### */}
              </div>
            </div>
          </div>
        </div>
      </section>


      
      {/* ###################### Modal Edit TimeSheet  ###################### */}
        
      <div className="modal fade" id="modal-TimeSheet" >
        <div className="modal-dialog modal-lg ">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <i className="fa fa-table" /> Time sheet - Transaction{" "}
              </h4>
              <button
                id="modalTS_Close"
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pt-1">
              <div className="form-horizontal ">
              <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label">
                    Customer
                  </span>
                  <span className="text-sm col-sm-10 col-form-label ">
                    <span id="lbl_modalTS_CusName" className="text-bold"></span>
                  </span>
                </div>

                <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label">
                    Project
                  </span>
                  <span className="text-sm col-sm-10 col-form-label ">
                    <span id="lbl_modalTS_ProjectName" className="text-bold"></span>{" "}
                  
                  </span>
                </div>

                {(data_modalTS_act_task_timeoff === "T" && 
                  <>
                    <div className="form-group row m-0">
                      <span className="text-sm col-sm-2 col-form-label">Task</span>
                      <span className="text-sm col-sm-10 col-form-label ">
                        <span className="text-bold">{data_modalTS_Task}</span>
                      </span>
                    </div>
                    <div className="form-group row m-0">
                      <span className="text-sm col-sm-2 col-form-label">Sub Task</span>
                      <span className="text-sm col-sm-10 col-form-label ">
                        <span className="text-bold">{data_modalTS_SubTask}</span>
                      </span>
                    </div>
                  </>
                ) ||
                (
                  <>
                    <div className="form-group row m-0">
                        <span className="text-sm col-sm-2 col-form-label">Time off</span>
                        <span className="text-sm col-sm-10 col-form-label ">
                            <span className="text-bold">{data_modalTS_Timeoff}</span>
                        </span>
                    </div>
                  </>
                )}

                
                <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label">Position</span>
                  <span className="text-sm col-sm-10 col-form-label">
                    <span id="lbl_modalTS_PositionName" className="text-bold"></span>
                  </span>
                </div>
                <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label">Date</span>
                  <span className="text-sm col-sm-10 col-form-label ">
                    <span className=" text-bold" id="lbl_modalTS_Day" ></span>{" "}
                    <span className="text-bold">
                      <span id="lbl_modalTS_Date"></span>{" "}<i id="i_model_Today" className="far fa-star text-warning" title="Today" />
                    </span>
                  </span>
                </div>
                
              </div>
              
              <div className="form-horizontal">
                <div className="form-group row m-0 mt-2">
                  <span className="text-sm col-sm-2 col-form-label ">
                    {(data_modalTS_act_task_timeoff === "T" && 
                    <>
                      <span id="span_modalTS_WorkTime" >
                      Work Time{" "}<i className="far fa-clock" />
                      </span>
                    </>) ||
                    <>
                      <span id="span_modalTS_Timeoff" >
                      Timeoff{" "}<i className="far fa-pause-circle" />
                      </span>
                    </>
                    }
                    <span className="text-danger">*</span>{" "}
                  </span>
                  <div className="col-sm-10">
                    <div className="row">
                      <div className="col-sm-5">
                        <div className="input-group">
                          {data_modalTS_wt_time === "" || data_modalTS_wt_time === "00:00" ? 
                            <>
                              <span className="form-control form-control-sm pl-2  span-lable mt-0 border p-1 bg-light">
                                -
                              </span>
                            </>
                              :  
                            <>
                              <span className="form-control form-control-sm pl-2  span-lable mt-0 border p-1 bg-light">
                                {data_modalTS_wt_time.substring(0, 2) === "00" ? "" : 
                                <>
                                  {data_modalTS_wt_time.substring(0, 1) === "0" ? 
                                      <>
                                          {data_modalTS_wt_time.substring(1,2)}
                                           <span >h</span> 
                                      </> 
                                      : 
                                      <>
                                          {data_modalTS_wt_time.substring(0, 2)}
                                          <span >h</span> 
                                      </>
                                  }
                                </>
                                }
                                 
                                {data_modalTS_wt_time.substring(3) === "00" ? "" : 
                                <>
                                  {" "}
                                  {/* {data_modalTS_wt_time.substring(3)} */}
                                  {parseInt(data_modalTS_wt_time.substring(3))} 
                                  <span >m</span> 
                                </>
                                }
                              </span>
                            </>
                          }
                        </div>
                      </div>
                      
                      {(data_modalTS_act_task_timeoff === "T" && isSVOT && 
                      <>
                        <span id="span_modalTS_OverTime" className="col-lg-2 col-sm-12 col-12 text-sm col-form-label text-right">
                          {" "}
                          Over Time{" "}<i className="far fa-lightbulb" />
                        </span>
                        <div id="div_modalTS_OverTime" className="col-sm-5">
                          <div className="input-group">
                            {data_modalTS_ot_time === "" || data_modalTS_ot_time === "00:00" ? 
                              <>
                                <span className="form-control form-control-sm pl-2  span-lable mt-0 border p-1 bg-light">
                                  -
                                </span>
                              </>
                              :  
                              <>
                                <span className="form-control form-control-sm pl-2  span-lable mt-0 border p-1 bg-light">
                                  {data_modalTS_ot_time.substring(0, 2) === "00" ? "" : 
                                  <>
                                    {data_modalTS_ot_time.substring(0, 1) === "0" ? 
                                        <>
                                            {data_modalTS_ot_time.substring(1,2)}
                                             <span >h</span> 
                                        </> 
                                        : 
                                        <>
                                            {data_modalTS_ot_time.substring(0, 2)}
                                            <span >h</span> 
                                        </>
                                    }
                                  </>
                                  }
                                  
                                  {data_modalTS_ot_time.substring(3) === "00" ? "" : 
                                  <>
                                    {" "}
                                    {/* {data_modalTS_ot_time.substring(3)} */}
                                    {parseInt(data_modalTS_ot_time.substring(3))} 
                                    <span className="text-small">m</span> 
                                  </>
                                  }
                                </span>
                              </>
                            }
                          </div>
                        </div>
                      </>)}




                    </div>
                  </div>
                </div>

                <div className="row m-0 mt-2" id="div_modalTS_Expenses1" >
                <span
                    className="text-sm col-lg-2 col-sm-2 col-12 col-form-label "
                  >
                    Expenses{" "}<i className="far fa-money-bill-alt" />
                  </span>
                  <div className="col-sm-10 m-0">
                    <div className="row mt-1">
                      <div className="col-sm-5 ">
                          <span className="text-sm"> Per diem allowance </span>
                          <div className="input-group">
                            <div className="form-control form-control-sm pl-2  span-lable mt-0 border p-1 bg-light">
                              {(data_modalTS_Extra > 0 ?Returncomma(data_modalTS_Extra) : " ")}
                            </div>
                            <div className="input-group-append">
                              <span className="input-group-text text-sm"><i className="fab fa-btc" title="baht"></i>&nbsp; </span>
                            </div>
                          </div>
                          
                      </div>
                      <div className="col-sm-2">
                        &nbsp;
                      </div>
                      <div className="col-sm-5">
                      <span className="text-sm"> Per diem allowance </span>
                          <div className="input-group">
                            <div className="form-control form-control-sm pl-2 span-lable mt-0 border p-1 bg-light">
                              {(data_modalTS_Extra_day > 0 ? ReturncommaCustom(data_modalTS_Extra_day, 0 , 0): " ")}
                            </div>
                            <div className="input-group-append">
                                <span className="input-group-text text-sm">day </span>
                              </div>
                          </div>

                      </div>
                    </div>
                    
                    <div className="row mt-1">
                      <div className="col-sm-5">
                        <span className="text-sm"> Travel  </span>
                        <div className="input-group">
                          <div className="form-control form-control-sm pl-2 span-lable  mt-0 border p-1 bg-light">
                            {(data_modalTS_Travel > 0 ? Returncomma(data_modalTS_Travel) : " ")}
                          </div>
                          <div className="input-group-append">
                                <span className="input-group-text text-sm"><i className="fab fa-btc" title="baht"></i> &nbsp;</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        &nbsp;
                      </div>
                      <div className="col-sm-5">
                        <span className="text-sm"> Travel Distance  </span>
                        <div className="input-group">
                            <div className="form-control form-control-sm pl-2 span-lable  mt-0 border p-1 bg-light">
                              {(data_modalTS_Travel_distance > 0 ? Returncomma(data_modalTS_Travel_distance) : " ")}
                            </div>
                            <div className="input-group-append">
                                <span className="input-group-text text-sm">km</span>
                            </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-1">
                      <div className="col-sm-5">
                        <span className="text-sm"> Other  </span>
                        <div className="input-group">
                            <div className="form-control form-control-sm pl-2 span-lable  mt-0 border p-1 bg-light">
                              {(data_modalTS_Other > 0 ? Returncomma(data_modalTS_Other) : " ")}
                            </div>
                              <div className="input-group-append">
                                <span className="input-group-text text-sm"><i className="fab fa-btc" title="baht"></i> &nbsp;</span>
                              </div>
                          </div>

                      </div>
                      <div className="col-sm-2">
                        &nbsp;
                      </div>
                      <div className="col-sm-5">
                        </div>
                    </div>

                  </div>
                </div>
               
                <div className="form-group row m-0 mt-2">
                  <span className="text-sm col-sm-2 col-form-label">
                    Note
                  </span>
                  <div className="col-sm-10">
                    <span id="lbl_modalTS_Note" className="span-lable">
                    </span>
                  </div>
                </div>


                <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label">
                    Status
                  </span>
                  <div className="col-sm-10 mt-1">
                    {
                    (data_modalTS_tss === ConfigETC.TS_ToReview_Value && 
                      <span className={ConfigETC.TS_ToReview_Class}>{ConfigETC.TS_ToReview_Text}</span>
                    ) ||
                    (data_modalTS_tss === ConfigETC.TS_ToApprove_Value && 
                      <span className={ConfigETC.TS_ToApprove_Class}>{ConfigETC.TS_ToApprove_Text}</span>
                    ) ||
                    (data_modalTS_tss === ConfigETC.TS_Approved_Value && 
                      <span className={ConfigETC.TS_Approved_Class}>{ConfigETC.TS_Approved_Text}</span>
                    ) ||
                    (data_modalTS_tss === ConfigETC.TS_Clearing_Value && 
                      <span className={ConfigETC.TS_Clearing_Class}>{ConfigETC.TS_Clearing_Text}</span>
                    )||
                    (data_modalTS_tss === ConfigETC.TS_Reject_Value && 
                      <span className={ConfigETC.TS_Reject_Class}>{ConfigETC.TS_Reject_Text}</span>
                    ) ||
                    (<span className={ConfigETC.TS_InProgress_Class}>{ConfigETC.TS_InProgress_Text}</span>
                    )
                    }
                    {(data_modalTS_tsssn !== "" || data_modalTS_tsd !== "") && <>
                      <span className="text-sm col-sm-10 col-form-label text-small">
                        <i className="fa fa-user" />{" "}{data_modalTS_tsssn}{" "}{data_modalTS_tsd}
                      </span>
                    </>}


                  </div>
                </div>

                {(data_modalTS_tsrd !== "" && (    (data_modalTS_tss !== ConfigETC.TS_Approved_Value) 
                                                && (data_modalTS_tss !== ConfigETC.TS_Clearing_Value)
                                            ) && 
                  <>
                    <div className="form-group row m-0">
                      <span className="text-sm col-sm-2 col-form-label">
                        Reject desc
                      </span>
                      <span className="text-sm col-sm-10 col-form-label text-small">
                        {data_modalTS_tsrd}{" "}<i className="fa fa-user" />{" "}{data_modalTS_tsrd2}{" "}{data_modalTS_tsrd3}
                      </span>
                    </div>
                  </>
                )}

                {data_modalTS_ActProject === "Edit" && 
                <>
                  <div className="form-group row m-0">
                    <span className="text-sm col-sm-2 col-form-label">
                      Last Update{" "}
                    </span>
                    <span className="text-sm col-sm-10 col-form-label text-small">
                      <i className="fa fa-user" />{" "}{data_modalTS_usn}{" "}{data_modalTS_ud}
                    </span>
                  </div>
                </>
                }
              </div>
            </div>

          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      
      {/* ###################### Modal Edit TimeSheet  ###################### */}
      

    </>
  );
}

function IconTodayShoworNot(props) {
  const { isshow } = props;
  if (isshow === "show") {
    return (
      <>
        <span className="today-icon">
          <i className="far fa-star text-small text-warning" title="today" />
        </span>
      </>
    );
  } else {
    return <></>;
  }
}

function ShowTimehrmm(props) {
  const { timehr, timemm } = props;

  return (
    <>
      {timehr !== "0" && timehr !== "" && (
        <>
          {timehr}
          <span className="text-normal">h</span>
        </>
      )}
      &nbsp;
      {timemm !== "0" && timemm !== "" && (
        <>
          {timemm}
          <span className="text-normal">m</span>
        </>
      )}
    </>
  );
}

export default PV_TimesheetbyStaff;
